import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { navigate } from '@redwoodjs/router';

import Button from 'src/components/Button';
import { Flex } from 'src/components/Flex';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import { CommissionStatusChip } from 'src/features/finance/commissionStatement/components/CommissionsStatusChip';
import { formatDate } from 'src/utils/utils';

export const commissionStatementsGridColDefs = (handleView: ({ id }: { id: number }) => void) => {
    return [
        createColumnDef({
            field: 'commissionStatementId',
            headerName: 'ID',
        }),
        createColumnDef({
            field: 'partnerName',
            headerName: 'Partner Name',
        }),
        createColumnDef({
            field: 'totalCommission',
            headerName: 'Commission',
        }),
        createColumnDef({
            field: 'statementDate',
            headerName: 'Statement Date',
            align: 'center',
            renderCell: ({ row }) => {
                return (
                    <Flex alignItems={'center'} height={'100%'}>
                        {formatDate({ date: new Date(row.statementDate)})}
                    </Flex>
                );
            },
        }),
        createColumnDef({
            field: 'billingCycle',
            headerName: 'Billing Cycle',
        }),
        createColumnDef({
            field: 'selfBillingInvoiceId',
            headerName: 'Self-Billing Invoice',
            renderCell: ({ row }) => {
                const selfBillingInvoice = row?.selfBillingInvoice;
                return (
                    <Button
                        disabled={!selfBillingInvoice?.id}
                        variant="text"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (selfBillingInvoice?.id) {
                                navigate(`/finance/self-billing-invoices/${selfBillingInvoice?.id}`);
                            }
                        }}
                    >
                        {selfBillingInvoice?.sageInvoiceNumber}
                    </Button>
                );
            },
        }),
        createColumnDef({
            field: 'status',
            headerName: 'Status',
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <Flex alignItems={'center'} height={'100%'} justifyContent={'center'}>
                        <CommissionStatusChip status={params.row.status} />
                    </Flex>
                );
            },
        }),
        createColumnDef({
            field: 'actions',
            disableColumnMenu: true,
            flex: 0,
            minWidth: 160 / 3,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <Flex alignItems={'center'} height={'100%'} justifyContent={'center'}>
                        <IconButton
                            onClick={() => {
                                handleView(params.row.id);
                            }}
                            aria-label="view"
                        >
                            <VisibilityIcon />
                        </IconButton>
                    </Flex>
                );
            },
        }),
    ];
};

export default commissionStatementsGridColDefs;
